import { useEffect } from "react";
import { generatePath, Link } from "react-router-dom";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Stack,
  Pagination,
  Tooltip,
  IconButton,
} from "@mui/material";

import nameof from "ts-nameof.macro";

import { dateToStringLong } from "../../../common/utils/dateTime";
import { PublicRoutesConfig } from "../../RoutesConfig";
import useUserContext from "../../../hooks/useUserContext";
import AlertExtended from "../../../common/components/mui-extended/AlertExtended";
import vehicleContractService from "../../../services/vehicleContractService";
import { PageDefaults } from "../../../common/interfaces/PageDto";
import {
  VehicleContractWaitingSearchDto,
  VehicleContactWaitingSearchResultDto,
} from "../../../interfaces/VehicleContract";
import { useSearchForm } from "../../../common/hooks/useSearchForm";

export default function Waiting() {
  const { userId } = useUserContext();

  const defaultModel: VehicleContractWaitingSearchDto = {
    ...PageDefaults,
    userId: userId,
  };

  const searchAsync = async (query: string) => {
    await vehicleContractService.getWaitingVehicleContractsAsync(query).then(async ({ data }) => {
      await vehicleContractService.getWaitingVehicleContractsCountAsync(query).then(({ data: count }) => {
        form.setResults(data, count);
      });
    });
  };

  const form = useSearchForm<VehicleContractWaitingSearchDto, VehicleContactWaitingSearchResultDto>({
    defaultModel: defaultModel,
    rootSearchPath: PublicRoutesConfig.Vehicle.Waiting.Path,
    searchAsync: searchAsync,
  });

  useEffect(() => {
    form.onSubmit();
  }, []);

  const renderTable = () => {
    return form.results && form.results.length > 0 ? (
      <>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Дата на получаване</TableCell>
                <TableCell>УРИ на преписка</TableCell>
                <TableCell>Регистрационен номер на ППС</TableCell>
                <TableCell>Рама на ППС</TableCell>
                <TableCell width="45px"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {form.results.map((item) => (
                <TableRow key={item.vehicleContractId} hover>
                  <TableCell>{dateToStringLong(item.createDate)}</TableCell>
                  <TableCell>{item.caseURI}</TableCell>
                  <TableCell>{item.vehicleRegistrationNumber}</TableCell>
                  <TableCell>{item.vehicleIdentificationNumber}</TableCell>
                  <TableCell>
                    <Stack direction="row">
                      <Tooltip title={PublicRoutesConfig.Vehicle.Edit.Label}>
                        <IconButton
                          component={Link}
                          to={generatePath(PublicRoutesConfig.Vehicle.New.Path, {
                            id: item.vehicleContractId?.toString(),
                          })}
                        >
                          {PublicRoutesConfig.Vehicle.Edit.Icon}
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Pagination
          count={form.pageCount}
          onChange={form.onPageChanged}
          page={form.watch(nameof(defaultModel.currentPage))}
        />
      </>
    ) : (
      form.searched && <AlertExtended type="warning">Няма чакащи договори.</AlertExtended>
    );
  };

  return (
    <Stack spacing={3}>
      <Typography variant="h5">Чакащи договори</Typography>
      {renderTable()}
    </Stack>
  );
}
